import { Box } from '@mui/material';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@Components/Button';
import MainSectionLayout from '@Components/MainSectionLayout';
import SearchBar from '@Components/SearchBar';

import StateTsrLayoutProps from './StateTsrLayout.types';

const StateTsrLayout: FunctionComponent<StateTsrLayoutProps> = (
  props: StateTsrLayoutProps
): JSX.Element => {
  const { searchProps, stateTsrAddBtnClick, ...resProps } = props;

  /** Translation Hook */
  const { t } = useTranslation();

  /** Table Filters */
  const filtersComponent = (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        mb={1.6}
      >
        <SearchBar {...searchProps} maxWidth={33.3} />
        <Button
          color="primary"
          icon="add"
          text={t('common.messages.Add Tsr')}
          onClick={stateTsrAddBtnClick}
        />
      </Box>
    </>
  );

  return <MainSectionLayout filters={filtersComponent} {...resProps} />;
};

export default StateTsrLayout;
